import { Router } from '@angular/router';
import { AuthService } from './../../../services/auth.service';
import { StoreService } from './../../../services/store.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menue',
  templateUrl: './menue.component.html',
  styleUrls: ['./menue.component.css']
})
export class MenueComponent implements OnInit {
  constructor(private store: StoreService, public authService: AuthService, private router: Router) { }
  hasDroitCommande: boolean;
  hasDroitCommandeNafama: boolean;
  hasDroitCommandeOmy: boolean;
  hasDroitCommandeProduit: boolean; 
  hasDroitAcceuil: boolean;
  hasDroitSuiviCommande: boolean;
  hasDroitAdmin: boolean;
  hasDroitChargement: boolean;
  hasDroitCommandeReelle: boolean;
  hasDroitMesVentes: boolean;
  hasDroitCommission: boolean;
  hasDroitMarges: boolean;
  hasDroitCashInCashOut: boolean;
  hasDroitCoPvRegion: boolean;
  hasDroitTableauBord: boolean;
  hasDroitCompte: boolean;
  hasDroitAide: boolean;
  hasDroitReporting: boolean;
  hasDroitPerformanceReporting: boolean;
  allUserDroit: any;

  async ngOnInit() {
    //this.allUserDroit = await this.store.getValue('allUserCode');
    this.hasDroitCommande = await this.hasDroit('MENU_000');
    this.hasDroitCommandeNafama = await this.hasDroit('MENU_001');
    this.hasDroitCommandeOmy = await this.hasDroit('MENU_002');
    this.hasDroitCommandeProduit = await this.hasDroit('MENU_003');
    this.hasDroitSuiviCommande = await this.hasDroit('MENU_004');
    this.hasDroitAdmin = await this.hasDroit('MENU_005');
    this.hasDroitChargement = await this.hasDroit('MENU_006');
    this.hasDroitAcceuil = await this.hasDroit('MENU_007');
    this.hasDroitCommandeReelle = await this.hasDroit('MENU_008');
    this.hasDroitMesVentes = await this.hasDroit('MENU_009');
    this.hasDroitCommission = await this.hasDroit('MENU_010');
    this.hasDroitMarges = await this.hasDroit('MENU_011');
    this.hasDroitCashInCashOut = await this.hasDroit('MENU_012');
    this.hasDroitCoPvRegion = await this.hasDroit('MENU_013');
    this.hasDroitTableauBord = await this.hasDroit('MENU_014');
    this.hasDroitCompte = await this.hasDroit('MENU_015');
    this.hasDroitAide = await this.hasDroit('MENU_016');
    this.hasDroitPerformanceReporting = [
      this.hasDroitMesVentes,
      this.hasDroitMarges,
      this.hasDroitCashInCashOut,
      this.hasDroitCoPvRegion,
      this.hasDroitTableauBord
    ].some(Boolean);
    this.hasDroitReporting = this.hasDroitPerformanceReporting || this.hasDroitCommission || this.hasDroitAdmin;
  }

  private async hasDroit(code: string) {
    return (await this.authService.hasDroit(code)) || this.hasCurrentUserDroit(code);
  }

  private hasCurrentUserDroit(code: string) {
    const user = this.authService.currentUser || this.store.currentUser;
    const droits = user && user.profil && user.profil.listDroit;
    return Array.isArray(droits) && droits.some(droit => droit.code === code);
  }

  onHistoriqueCommande(event){
    event.preventDefault()
      sessionStorage.setItem("DISPALAY_COMMANDES_DISTRI_ALL", "OK");
      this.router.navigateByUrl('/root/etat-commande');
    }
    onValidateCommande(event){
      event.preventDefault()
      sessionStorage.setItem("DISPALAY_COMMANDES_DISTRI_ALL", "ROLE");
      this.router.navigateByUrl('/root/validation-commande');
    }

}
